import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getAvailableEquipment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT,
		ModulesConfigMap[ModulesMap.EQUIPMENT].GET_AVAILABLE_EQUIPMENT,
		options
	)
}

function _getEquipment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT,
		ModulesConfigMap[ModulesMap.EQUIPMENT].GET_EQUIPMENT,
		options
	)
}


function _getPreviewEquipment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT,
		ModulesConfigMap[ModulesMap.EQUIPMENT].GET_PREVIEW_EQUIPMENT,
		options
	)
}

function _getPopupEquipment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT,
		ModulesConfigMap[ModulesMap.EQUIPMENT].GET_POPUP_EQUIPMENT,
		options
	)
}

function _createEquipment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT,
		ModulesConfigMap[ModulesMap.EQUIPMENT].CREATE_EQUIPMENT,
		options
	)
}

function _patchEquipment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT,
		ModulesConfigMap[ModulesMap.EQUIPMENT].PATCH_EQUIPMENT,
		options
	)
}

function _putEquipment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT,
		ModulesConfigMap[ModulesMap.EQUIPMENT].PUT_EQUIPMENT,
		options
	)
}

function _deleteEquipment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT,
		ModulesConfigMap[ModulesMap.EQUIPMENT].DELETE_EQUIPMENT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT].GET_AVAILABLE_EQUIPMENT]: _getAvailableEquipment,

	[ModulesConfigMap[ModulesMap.EQUIPMENT].GET_EQUIPMENT]: _getEquipment,

	[ModulesConfigMap[ModulesMap.EQUIPMENT].GET_PREVIEW_EQUIPMENT]: _getPreviewEquipment,

	[ModulesConfigMap[ModulesMap.EQUIPMENT].GET_POPUP_EQUIPMENT]: _getPopupEquipment,

	[ModulesConfigMap[ModulesMap.EQUIPMENT].CREATE_EQUIPMENT]: _createEquipment,

	[ModulesConfigMap[ModulesMap.EQUIPMENT].PATCH_EQUIPMENT]: _patchEquipment,

	[ModulesConfigMap[ModulesMap.EQUIPMENT].PUT_EQUIPMENT]: _putEquipment,

	[ModulesConfigMap[ModulesMap.EQUIPMENT].DELETE_EQUIPMENT]: _deleteEquipment,
}
